import { FileServicesUnion } from 'shared/domain/messages/httpQueue/eventMessages';
import { TranslationKey } from 'intl/types/translationKey';

export enum Progress {
  PENDING = 'PENDING',
  UPLOADED = 'UPLOADED',
  FAILED = 'FAILED',
}

export type UploadProgresStatus =
  | Progress.PENDING
  | Progress.UPLOADED
  | Progress.FAILED;

export interface UploadProgresFile {
  uniqueFileId: string;
  status: UploadProgresStatus;
  localId?: number;
  type: FileServicesUnion;
  title: string;
  // Set for entries whose label should be translated (e.g. "Creating
  // folders..."), as opposed to a literal file name.
  titleTranslationKey?: TranslationKey;
}

export interface UploadProgressStoreState {
  files: UploadProgresFile[];
}

export interface UploadProgressStoreActions {
  addPendingUploadPlaceholders: (
    items: {
      title: string;
      type: FileServicesUnion;
      titleTranslationKey?: TranslationKey;
    }[]
  ) => string[];
  markUploadPlaceholderFailed: (uniqueFileId: string) => void;
  /** Follows the uploads of documents and documentation; returns the unsubscribe. */
  subscribeToChannelMessages: () => () => void;
  /** Drops the queued uploads of the files still uploading. */
  abortPendingUploads: () => void;
  updateFileWhere: (
    predicate: (file: UploadProgresFile) => boolean,
    updates: Partial<UploadProgresFile>
  ) => void;
  removeFile: (uniqueFileId: string) => void;
  clearFiles: () => void;
}

export type UploadProgressSlice = UploadProgressStoreState &
  UploadProgressStoreActions;
